jQuery(document).ready(function ($) {

    function tense_equalize_slides($slides) {
        if (Foundation.MediaQuery.atLeast('medium')) {
            var max_height = 0;
            $slides.each(function () {
                max_height = Math.max($(this).height(), max_height);
            });
            $slides.height(max_height);
        } else {
            $slides.css('height', 'auto');
        }
    }

    $('[data-slider-equalize]').on('init reInit', function (event, slick) {
        tense_equalize_slides(slick.$slides);
    });

    function tense_resize_handler() {
        $tense_sliders.each(function () {
            var slick = $(this).slick('getSlick');
            tense_equalize_slides(slick.$slides);
        });
    }

    var $tense_sliders = $('[data-slider-equalize]');

    if ($tense_sliders.length) {
        var resize_timer;

        $(window).resize(function () {
            clearTimeout(resize_timer);

            resize_timer = setTimeout(tense_resize_handler, 200);
        });
    }

    $('.slider-home').on('init', function (event, slick) {
        $(".slider-home [data-slick-index='" + slick.currentSlide + "'] video").each(function () {
            this.play()
        });
    });

    $('.slider-home').slick({
        dots: true,
        speed: 300,
        infinite: true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        arrows: false,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });

    $('.slider-home').on('afterChange', function (event, slick, currentSlide) {
        $(".slider-home [data-slick-index='" + currentSlide + "'] video").each(function () {
            this.play()
        });
    });

    $('.slider-home').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(".slider-home [data-slick-index='" + currentSlide + "'] video").each(function () {
            this.pause()
        });
    });


    $('.home-slider').slick({
        dots: true,
        speed: 1000,
        infinite: true,
        autoplay: false,
        cssEase: 'ease-out',
        arrows: false,
        fade: true,
    });

    $('.product__slider--main').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        autoplay: false,
        cssEase: 'ease-out',
        arrows: false,
        fade: true,
        responsive: [
            {
                breakpoint: 640,
                settings: "unslick",
            },
        ],
    });

    $('.product__slider--nav').slick({
        dots: false,
        speed: 1000,
        infinite: true,
        autoplay: false,
        cssEase: 'ease-out',
        arrows: false,
        fade: false,
        vertical: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        focusOnSelect: true,
        asNavFor: '.product__slider--main',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    vertical: false,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    vertical: false,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    vertical: false,
                }
            }
        ],
    });

    $('.home-slider-partners').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        rows: 0,
        speed: 800,
        autoplay: true,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                }
            }
        ]
    });

    $('.home-products__slider').slick({
        dots: false,
        speed: 1500,
        infinite: true,
        autoplay: true,
        cssEase: 'ease-out',
        arrows: true,
        fade: false,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

});
